import { Box, Chip, Typography, IconButton, Grid } from '@mui/material';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { fetchDropDownValues, setBusinessUnit } from '../../store/APISlice';
import { getDropDownFlag, setDropDownLoadedFlag, setDropdownReducer } from '../../store/formSlice';
import { useAppDispatch } from '../../store/store';
import UserProfile from '../userProfile/UserProfile';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import './Home.css';

const Home = () => {
  const [activeUnit, setActiveUnit] = useState<string>('');
  const [showMore, setShowMore] = useState(false); // State to track showing more items

  const businessUnits = [
    { name: 'PTRA', description: 'pepsilogistics@pepsico.com: This is the Traditional team – We handle Dairy Farmers America Bottles, DFA orders, Frito Lay, Plant to Plant Transfers, Special Events, Projects, and R&D orders. Most orders require Cost Center, DIVLOC, PEPLOC or Account number depending on what location they are being shipped into.' },
    {
      name: 'PBCI', description: 'spapeplogisticspbc@pepsico.com - Pepsi Bottle Company Team: This will include all COLD-Fill bottlers. This team handles orders for Pepsi plants to include:', listDescription: `
                    <ul>
                      <li>Cans</li>
                      <li>Lids</li>
                      <li>Preforms</li>
                      <li>Labels</li>
                      <li>Corrugate</li>
                      <li>Dunnage for the Pepsi plants</li>
                      <li>Rockstar plants</li>
                      <li>Dry Sugar</li>
                      <li>Shrink Wrap</li>
                      <li>Closures</li>
                      <li>BIB</li>
                      <li>Paperboard</li>
                      <li>Perm Merchandise</li>
                      <li>North American Coffee Partnership</li>
                      <li>Canadian Pepsi Bottlers</li>
                    </ul>` },
    { name: 'PQGI', description: 'logistics_qginbound@pepsico.com - This is the Quaker and Gatorade Team. They handle ingredients for the plants to produce product for Quaker and Gatorade. This includes labels, bottles, corrugate, and seasoning that include salts and sugars. Orders will require a 10-digit PO starting with a 45 or 76.' },
  ];

  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const isDropdownLoaded = useSelector(getDropDownFlag);

  const handleChipClick = (unit: string) => {
    dispatch(setBusinessUnit(unit));
    setActiveUnit(unit);
    setShowMore(false); // Reset showMore state when a new unit is selected
    goToInboundAutomation(unit);
  };

  const goToInboundAutomation = (unit: string) => {
    navigate('/Inbound-Automation');
  };

  const toggleShowMore = () => {
    setShowMore(prev => !prev);
  };

  useEffect(() => {
    if (!isDropdownLoaded) {
      const fetchData = () => {
        dispatch(fetchDropDownValues())
          .then((res: any) => {
            if (res?.payload.status === 200) {
              dispatch(setDropdownReducer(res?.payload.data?.response));
              dispatch(setDropDownLoadedFlag());
            }
          })
          .catch((err: any) => {
            console.error('Error fetching data:', err);
          });
      };

      fetchData();
    }
  }, [isDropdownLoaded, dispatch]);

  return (
    <>
      <UserProfile />
      <div
        className="container"
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh',
          overflowY: 'auto',
        }}
      >
        <div className="containerBox">
          <Grid
            container
            spacing={2}
            justifyContent="center"
            alignItems="center"
            sx={{
              bgcolor: 'transparent',
              padding: 2,
              textAlign: 'center',
              border: 'none',
            }}
          >
            <Grid item xs={12}>
              <Typography
                variant="h4"
                gutterBottom
                sx={{
                  fontSize: { xs: '1rem', sm: '1.5rem', md: '2rem', lg: '2.125rem' }, // Further reduce font size for smaller screens
                  textAlign: 'center',
                  marginTop: '20px', // Add margin to bring it down
                }}
              >
                Please Select Business Unit
              </Typography>
            </Grid>

            <Grid
              item
              container
              spacing={4} // Increase spacing between the boxes
              justifyContent="center"
              alignItems="center" // Center items vertically
              sx={{
                flexDirection: 'row',
                width: '100%', // Ensure the container spans the full width
                margin: 0, // Remove any default margins
                paddingLeft: { xs: 0, sm: 4 }, // No left margin for smaller screens
                paddingRight: { xs: 0, sm: 4 }, // No right margin for smaller screens
                '@media (max-width: 1024px)': {
                  paddingLeft: 0, // Remove left padding for iPad devices
                  paddingRight: 0, // Remove right padding for iPad devices
                },
              }}
            >
              {businessUnits.map((unit) => (
                <Grid
                  item
                  key={unit.name}
                  xs={12} // Full width on extra small screens
                  sm={6} // Half width on small screens
                  md={4} // One-third width on medium screens
                  lg={3} // One-fourth width on large screens
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    gap: 1,
                    padding: 2,
                    border: '1px solid rgba(255, 255, 255, 0.5)',
                    borderRadius: 2,
                    backgroundColor: 'rgba(0, 0, 0, 0.5)',
                    width: '100%',
                    height: activeUnit === unit.name ? 'auto' : '250px', // Reduced height
                    position: 'relative',
                    overflow: 'hidden',
                    '@media (max-width: 768px)': {
                      height: '200px', // Further reduce height for smaller screens
                      padding: 1, // Reduce padding for smaller screens
                    },
                  }}
                >
                  <Chip
                    label={unit.name}
                    onClick={() => handleChipClick(unit.name)}
                    variant={activeUnit === unit.name ? 'filled' : 'outlined'}
                    sx={{
                      backgroundColor:
                        activeUnit === unit.name
                          ? 'rgba(255, 255, 255, 0.4)'
                          : 'rgba(255, 255, 255, 0.2)',
                      '&:hover': {
                        backgroundColor: 'rgba(255, 255, 255, 0.3)',
                      },
                      color: '#fff',
                      position: 'relative',
                    }}
                  />
                  <Typography
                    sx={{
                      font: 'normal normal 10px Segoe UI',
                      paddingTop: '10px',
                      color: '#fff',
                      textAlign: 'center',
                      height: '40px',
                      position: 'relative',
                    }}
                  >
                    {unit.description}
                  </Typography>
                  {unit.listDescription && (
                    <Box
                      sx={{
                        position: 'relative',
                        color: '#fff',
                        textAlign: 'left',
                        width: '100%',
                        fontFamily: 'Segoe UI',
                        fontSize: '10px',
                        overflowY: 'auto',
                        maxHeight: '120px', // Reduced max height
                        marginTop: '10px',
                        '@media (max-width: 768px)': {
                          maxHeight: '80px', // Further reduce max height for smaller screens
                        },
                      }}
                    >
                      <div
                        dangerouslySetInnerHTML={{
                          __html: showMore
                            ? unit.listDescription
                            : unit.listDescription
                              .split('</li>')
                              .slice(0, 3)
                              .join('</li>') + '</li></ul>',
                        }}
                      />
                      <Box
                        sx={{ display: 'flex', justifyContent: 'center', marginTop: '10px' }}
                      >
                        <IconButton onClick={toggleShowMore} sx={{ color: '#fff' }}>
                          {showMore ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                        </IconButton>
                      </Box>
                    </Box>
                  )}
                </Grid>
              ))}
            </Grid>
          </Grid>
        </div>
      </div>
    </>
  );
};

export default Home;